module.exports = __webpack_public_path__ + "static/media/slider-12.3850cbcf.jpg";